import { t } from "i18next";
import React from "react";
import { toCamelCase } from "./Helpers";
import {
    PRODUCTS_STATUS,
    SUBSCRIPTION_TYPES,
    TAGS_CLASSNAMES,
    BOOLEAN_OPTIONS,
    STATUS_OPTIONS,
} from "./constants";

const generalFormatter = (status, conditions, matchLabel) => {
    const getInnerNodes = () => {
        for (let i = 0; i < conditions.length; i++) {
            if (status === conditions[i].case) {
                if (conditions[i].isIcon)
                    return (
                        <i
                            className={conditions[i].tagStyle}
                            style={conditions[i].styling}
                        />
                    );
                return (
                    <div className={`tag-ele ${conditions[i].tagStyle} px-2`}>
                        {matchLabel
                            ? t(toCamelCase(status))
                            : t(toCamelCase(conditions[i].tagLabel))}
                    </div>
                );
            }
        }

        return (
            <div className={`tag-ele ${TAGS_CLASSNAMES.unknown} px-2`}>
                {t(toCamelCase(TAGS_CLASSNAMES.unknown))}
            </div>
        );
    };

    return (
        <div className="flex items-center justify-center">
            {getInnerNodes()}
        </div>
    );
};

const productStatusFormatter = (status) => {
    const productStatus = [
        {
            case: PRODUCTS_STATUS.accepted,
            tagStyle: TAGS_CLASSNAMES.completed,
            tagLabel: PRODUCTS_STATUS.accepted,
        },
        {
            case: PRODUCTS_STATUS.rejected,
            tagStyle: TAGS_CLASSNAMES.declined,
            tagLabel: PRODUCTS_STATUS.rejected,
        },
        {
            case: PRODUCTS_STATUS.deprecated,
            tagStyle: TAGS_CLASSNAMES.completed,
            tagLabel: PRODUCTS_STATUS.deprecated,
        },
        {
            case: PRODUCTS_STATUS.underReview,
            tagStyle: TAGS_CLASSNAMES.inProgress,
            tagLabel: PRODUCTS_STATUS.underReview,
        },
    ];
    return generalFormatter(status, productStatus);
};

const durationFormatter = (status) => {
    const duration = [
        {
            case: SUBSCRIPTION_TYPES.trial,
            tagStyle: TAGS_CLASSNAMES.completed,
        },
        {
            case: SUBSCRIPTION_TYPES.monthly,
            tagStyle: TAGS_CLASSNAMES.bundle,
        },
        {
            case: SUBSCRIPTION_TYPES.annual,
            tagStyle: TAGS_CLASSNAMES.deployed,
        },
    ];
    return generalFormatter(status, duration, true);
};

const activeIconFormatter = (status) => {
    const active = [
        {
            case: BOOLEAN_OPTIONS.true,
            tagStyle: TAGS_CLASSNAMES.trueCheck,
            isIcon: true,
            styling: { color: "#4ac990", fontSize: "14px" },
        },
        {
            case: BOOLEAN_OPTIONS.false,
            tagStyle: TAGS_CLASSNAMES.falseCheck,
            isIcon: true,
            styling: { color: "#ff6600", fontSize: "14px" },
        },
    ];

    return generalFormatter(status, active, true);
};

const statusFormatter = (status) => {
    const active = [
        {
            case: STATUS_OPTIONS.active,
            tagStyle: TAGS_CLASSNAMES.completed,
        },
        {
            case: STATUS_OPTIONS.unpaid,
            tagStyle: TAGS_CLASSNAMES.deployed,
        },
        {
            case: STATUS_OPTIONS.expired,
            tagStyle: TAGS_CLASSNAMES.bundle,
        },
        {
            case: STATUS_OPTIONS.canceled,
            tagStyle: TAGS_CLASSNAMES.declined,
        },
    ];

    return generalFormatter(status, active, true);
};

export {
    productStatusFormatter,
    durationFormatter,
    activeIconFormatter,
    statusFormatter,
};
